import { useEffect, useRef, useState } from "react";

export default function CustomCursor() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    // Only enable on fine pointer + hover devices (desktop)
    const mm = window.matchMedia("(hover: hover) and (pointer: fine)");
    if (!mm.matches) return;
    // Respect reduced motion
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    setEnabled(true);
    document.documentElement.classList.add("custom-cursor-on");

    let x = window.innerWidth / 2;
    let y = window.innerHeight / 2;
    let rx = x;
    let ry = y;

    const onMove = (e) => {
      x = e.clientX;
      y = e.clientY;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate3d(${x - 4}px, ${y - 4}px, 0)`;
      }
    };

    const loop = () => {
      rx += (x - rx) * 0.18;
      ry += (y - ry) * 0.18;
      if (ringRef.current) {
        ringRef.current.style.transform = `translate3d(${rx - 18}px, ${ry - 18}px, 0)`;
      }
      raf = requestAnimationFrame(loop);
    };
    let raf = requestAnimationFrame(loop);

    const onOver = (e) => {
      const t = e.target;
      const interactive =
        t.closest("a, button, input, textarea, [role='button'], [data-testid*='cta']");
      if (ringRef.current) {
        ringRef.current.style.width = interactive ? "50px" : "36px";
        ringRef.current.style.height = interactive ? "50px" : "36px";
        ringRef.current.style.borderColor = interactive
          ? "rgba(0,229,255,0.7)"
          : "rgba(255,255,255,0.25)";
      }
    };

    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseover", onOver);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", onOver);
      document.documentElement.classList.remove("custom-cursor-on");
    };
  }, []);

  if (!enabled) return null;

  return (
    <>
      <div
        ref={ringRef}
        aria-hidden
        className="pointer-events-none fixed top-0 left-0 z-[9998] hidden md:block rounded-full border transition-[width,height,border-color] duration-300 ease-out"
        style={{
          width: 36,
          height: 36,
          borderColor: "rgba(255,255,255,0.25)",
          mixBlendMode: "difference",
        }}
      />
      <div
        ref={dotRef}
        aria-hidden
        className="pointer-events-none fixed top-0 left-0 z-[9999] hidden md:block w-2 h-2 rounded-full bg-white"
        style={{ mixBlendMode: "difference" }}
      />
    </>
  );
}
